import React from "react";

export interface SwitchSetModalProps {
	result: {
		setNumber: number;
		isCurrentSet: boolean;
	};
	totalSets: number;
	isGenerated: boolean;
}

export const SwitchSetModal: React.FC<SwitchSetModalProps> = ({
	result,
	totalSets,
	isGenerated,
}) => {
	if (isGenerated) {
		return (
			<div>
				<p>{`This lesson includes problems that are uniquely generated each time it is played.
          You are currently on problem set ${result.setNumber} of ${totalSets} fixed sample problem sets.`}</p>
				<p>{`Click a button below to go to another set.`}</p>
			</div>
		);
	} else if (!result.isCurrentSet) {
		return (
			<div>
				<p>{`You are currently on an outdated problem set. If you leave this set,
          you will not be able to resume your progress.`}</p>
				<p>{`Click a button below to go to a current set in this lesson.`}</p>
			</div>
		);
	} else if (totalSets > 1) {
		return (
			<div>
				<p>{`You are currently on problem set ${result.setNumber} of ${totalSets}.`}</p>
				<p>{`Click a button below to go to another set in this lesson.`}</p>
			</div>
		);
	} else {
		return <div>{`This lesson is does not have any other problem sets.`}</div>;
	}
};
